import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { RESIDENTIAL_CARDS, COMMERCIAL_CARDS } from "@/data/services";

const CardGrid = ({ cards }) => (
  <Stagger className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
    {cards.map((s) => (
      <StaggerItem key={s.name + s.href}>
        <Link
          to={s.href}
          data-testid={`service-card-${s.href.replace(/\//g, "")}`}
          className="group flex h-full flex-col rounded-3xl border border-slate-200/70 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-emerald-200 hover:shadow-[0_18px_50px_rgba(4,120,87,0.12)]"
        >
          <span className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700 transition-colors group-hover:bg-emerald-700 group-hover:text-white">
            <s.icon size={22} />
          </span>
          <h3 className="flex items-center gap-1 font-display text-xl font-bold text-slate-900">
            {s.name}
            <ArrowUpRight size={16} className="text-emerald-500 opacity-0 transition-opacity group-hover:opacity-100" />
          </h3>
          <p className="mt-2 flex-1 text-slate-600">{s.short}</p>
          <span className="mt-4 text-sm font-bold text-emerald-700">Learn More →</span>
        </Link>
      </StaggerItem>
    ))}
  </Stagger>
);

export const Services = () => (
  <section id="services" className="bg-white py-20 sm:py-28" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">What we do</p>
        <h2 className="mt-3 max-w-2xl font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          Our Cleaning Services
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">
          Residential and commercial cleaning for apartments, houses and business premises. Tap any
          service to see what's included and get a fast quote.
        </p>
      </Reveal>

      <Reveal><h3 className="mt-12 font-display text-2xl font-bold text-slate-900">Residential Cleaning</h3></Reveal>
      <CardGrid cards={RESIDENTIAL_CARDS} />

      <Reveal><h3 className="mt-14 font-display text-2xl font-bold text-slate-900">Commercial Cleaning</h3></Reveal>
      <CardGrid cards={COMMERCIAL_CARDS} />
    </div>
  </section>
);
